<template>
    <div>
        <div class="virtual_assistant-wrapper">
            <common-icon
                class="close-icon"
                name="close"
                size="medium"
                @click="emitEvent({ name: 'close-redirection' })"
            ></common-icon>
            <div v-show="!isChatActive" class="virtual-assistant">
                <div v-if="options" class="virtual-assistant--box">
                    <div class="virtual-assistant--box--container">
                        <common-icon name="chat-bot" size="gigantic"></common-icon>
                        <h2 class="virtual-assistant--box--header">{{ headerAnimatedText }}</h2>
                    </div>
                    <transition name="fade" mode="out-in">
                        <div v-show="animationFinished" class="virtual-assistant--box--container">
                            <common-button
                                v-for="(node, index) in options.nodes"
                                v-show="animationFinished && index < visibleButtons"
                                :key="node.value"
                                :isSubmittable="false"
                                :label="node.value"
                                type="link"
                                size="small-font"
                                :class="{ show: animationFinished && index < visibleButtons }"
                                @click="handleNodeClick(node)"
                            ></common-button>
                        </div>
                    </transition>
                    <common-icon
                        v-if="prevNodes.length > 0"
                        class="icon-back"
                        name="arrow-left"
                        size="huge"
                        @click="handleBack"
                    ></common-icon>
                </div>
            </div>
            <div v-show="isChatActive" class="chat-wrapper">
                <med-chat-component></med-chat-component>
            </div>
            <div class="chat-edha-button" @click="isChatActive = !isChatActive">
                <span>{{ $t('pages.assistant.virtual_assistant.chat_with_edha') }}</span>
                <common-icon name="chatgpt" size="huge"></common-icon>
            </div>
        </div>
        <div class="overlay"></div>
    </div>
</template>

<script>
    import redirectionOptions from 'pages/index/virtual-assistant//redirectionOptions.json'
    import cloneDeep from 'lodash.clonedeep'
    import MedChatComponent from './MedChatComponent.vue'

    export default {
        components: { MedChatComponent },
        data() {
            return {
                headerAnimatedText: '',
                headerIndex: 0,
                animationFinished: false,
                options: null,
                visibleButtons: 0,
                prevNodes: [],
                isChatActive: false,
            }
        },
        methods: {
            handleNodeClick(node) {
                this.visibleButtons = 0
                if (node.childrens && node.childrens.length > 0) {
                    this.prevNodes.push(cloneDeep(this.options))
                    this.options.nodes = node.childrens
                    this.options.header = node?.header
                    this.headerIndex = 0
                    this.headerAnimatedText = ''
                    this.typeHeader(node?.header)
                    this.animateButtons()
                } else {
                    this.emitEvent({ name: 'close-redirection' })
                    this.$router.push({ path: node.key })
                }
            },

            handleBack() {
                this.visibleButtons = 0
                if (this.prevNodes.length > 0) {
                    this.options = this.prevNodes.pop()
                    this.headerIndex = 0
                    this.headerAnimatedText = ''
                    this.typeHeader(this.options?.header)
                    this.animateButtons()
                }
            },

            typeHeader(text) {
                const speed = 10
                if (this.headerIndex < text?.length) {
                    this.headerAnimatedText += text.charAt(this.headerIndex)
                    this.headerIndex = this.headerIndex + 1
                    setTimeout(() => {
                        this.typeHeader(text)
                    }, speed)
                } else {
                    this.animationFinished = true
                    this.animateButtons()
                }
            },

            animateButtons() {
                if (this.visibleButtons < this.options.nodes.length) {
                    this.visibleButtons = this.visibleButtons + 1
                    setTimeout(this.animateButtons, 100)
                }
            },
        },

        mounted() {
            this.options = cloneDeep(redirectionOptions)
            this.typeHeader(this.options.header)
            localStorage.setItem('showRedirectionBox', true)
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/virtual-assistant/_virtual-assistant';
</style>
